import { Maybe } from "@shared/graphql.types";

export const fromMaybe = <T>(value: Maybe<T> | undefined): T | undefined => {
  return value === null ? undefined : value;
};

export const fromMaybeArray = <T>(
  value: Maybe<Maybe<T>[]> | undefined
): T[] | undefined => {
  if (value == null) return undefined;
  return value.filter((item): item is T => item != null);
};
